import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Settings {
  apiKey: string
  voiceId: string
}

interface SettingsState extends Settings {
  setSettings: (settings: Partial<Settings>) => void
  clearSettings: () => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      apiKey: '',
      voiceId: '',
      setSettings: (settings) => set((state) => ({ ...state, ...settings })),
      clearSettings: () => set({ apiKey: '', voiceId: '' }),
    }),
    {
      name: 'hype-beast-settings',
    }
  )
) 